import { Minus } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

const MinusIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Minus width={size} height={size} color={color} {...rest} />;

MinusIcon.displayName = 'MinusIcon';

export default MinusIcon;
